import { useContext } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { trackClickManageSeats } from '../utils/event-handlers';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const ManageSeatsBanner = ({
  onClose
}) => {
  const trackUsage = useContext(TrackUsageContext);
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "p-left-6 p-right-3",
    closeable: true,
    onClose: onClose,
    style: {
      margin: '-16px -20px',
      border: 'none'
    },
    type: 'tip',
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        UILink
      },
      message: "routing-ui.routingRules.roundRobin.manageSeatsFooter_jsx",
      options: {
        external: true,
        href: getUsersSeatsUrl(),
        onClick: () => trackUsage(trackClickManageSeats())
      }
    })
  });
};
ManageSeatsBanner.displayName = 'ManageSeatsBanner';
export default ManageSeatsBanner;